let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6rtB3")).then(() => parcelRequire('jrL5p'));